import { Accordion } from '@ui-kit/components/Accordion/Accordion';
import { cn } from '@ui-kit/utils';
import { type ComponentProps, createElement } from 'react';
import styled, { css } from 'styled-components';
import { Colors } from '@/ui-kit/colors';

export const modalAccordionStyles = css`
  margin-left: calc(-1 * var(--modal-horizontal-padding));
  margin-right: calc(-1 * var(--modal-horizontal-padding));
  margin-bottom: calc(-1 * var(--modal-vertical-padding));

  @media (min-width: 992px) {
    margin: 0;
  }
`;

const modalAccordionClassName =
  '-mx-[var(--modal-horizontal-padding)] -mb-[var(--modal-vertical-padding)] lg:m-0';

export const ModalAccordion = ({ className, ...props }: ComponentProps<typeof Accordion>) =>
  createElement(Accordion, { className: cn(modalAccordionClassName, className), ...props });

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 8px;
    border: 1px solid ${Colors.BORDER_DEFAULT};
  }
`;
